import React from 'react';
import classnames from 'classnames';

const Checkbox = ({
    checked = false,
    label = '',
    help = null,
    placeholder = null,
    id = 'input',
    name = null,
    validators = [],
    errors = false,
    touched = true,
    value = '',
    required = false,
    className = '',
    inline = false,
    disabled = false,
    children = null,
    onChange = () => {},
    onBlur = () => {}
}) => {
    return (
        <div
            className={classnames('form-group form-check', className, {
                'checkbox-inline': inline
            })}
        >
            <input
                className={classnames('form-check-input', {
                    success: touched && !errors,
                    error: errors
                })}
                checked={checked}
                value={value}
                type="checkbox"
                name={name || id}
                id={id}
                required={required}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
            />
            <label
                htmlFor={id}
                className={classnames('form-check-label', {
                    required: required
                })}
            >
                {label || children}
            </label>{' '}
            {help}
            {errors && (
                <div className="errors-list">
                    <span>{errors}</span>
                </div>
            )}
        </div>
    );
};

export default Checkbox;
